import React, { Component } from 'react';
import Utility from '../utility';
import StepView from '../views/StepView';

class StepController extends Component {
  validate(answers) {
    answers = answers.filter(answer => answer);

    const mostCommonLetter = Utility.mode(answers);

    return answers.filter(answer => answer === mostCommonLetter).length >= 3;
  }

  render() {
    return (
      <StepView
        {...this.props}
        {...this.state}
        validate={this.validate}
      />
    );
  }
}

export default StepController;
